import { Pipe, PipeTransform } from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Pipe({
    name: 'separateNumbers',
    standalone: false
})
export class SeparateNumbersPipe extends DecimalPipe {

  transform(value: any, digits?: string): any {
    return super.transform(value, digits).replace(',', ' ');
  }

}
